import React, { useState } from 'react';
import { QueryClient, QueryClientProvider, useQueryClient } from 'react-query';

import { topic_landing_path } from '../../../routes';
import { FollowType } from '../../../utils/backend-api/follow';
import { Button } from '../../BaseUI';
import FollowButton from '../FollowButton';
import styles from './styles.module.css';

type Entity = { id: number; name: string; following: boolean };

const INITIAL_ENTITY_COUNT = 5;

function Entity({ entity, isSignedIn }: { entity: Entity; isSignedIn: boolean }) {
  const queryClient = useQueryClient();

  return (
    <div className={styles.entity} data-test="explore-entities-entity">
      <a href={topic_landing_path(entity.name)} className={styles.entityName}>
        {entity.name}
      </a>
      <div>
        <FollowButton
          followStatus={entity.following}
          followeeId={entity.id}
          followType={FollowType.Entity}
          showSubscribeModal={!isSignedIn}
          queryClient={queryClient}
          name={entity.name}
        />
      </div>
    </div>
  );
}

const queryClient = new QueryClient();

export default function ExploreEntities({
  entities,
  isSignedIn,
}: {
  entities: Entity[];
  isSignedIn?: boolean;
}) {
  const [showAll, setShowAll] = useState(false);
  const visibleEntities = showAll ? entities : entities.slice(0, INITIAL_ENTITY_COUNT);

  return (
    <QueryClientProvider client={queryClient}>
      <div className={styles.exploreEntities}>
        <div className={styles.heading}>Explore Topics</div>
        {visibleEntities.map((entity) => (
          <Entity entity={entity} key={entity.id} isSignedIn={isSignedIn} />
        ))}
        {!showAll && entities.length > INITIAL_ENTITY_COUNT && (
          <div className={styles.showAll}>
            <Button onClick={() => setShowAll(true)} variant="muted">
              View More
            </Button>
          </div>
        )}
      </div>
    </QueryClientProvider>
  );
}
